
import Vue, { PropType } from 'vue';
import { mapActions, mapState, mapStores } from 'pinia';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useColorManagementStore } from '@/stores/v2/colorsManagement';
import { AnnotationShape } from '@/web-components/import-wizard-v2/typings/common';
import ColorManagement from '@/web-components/import-wizard-v2/components/ColorManagement/ColorManagement.vue';
import Divider from '../Divider/Divider.vue';
import ShowMore from '../ShowMore/ShowMore.vue';

export default Vue.extend({
  name: 'HomePanel',
  components: {
    Divider,
    ColorManagement,
    ShowMore,
  },

  props: {
    productDescription: { type: String, default: '' },
  },

  computed: {
    ...mapStores(useShapeStore, useProductStore),
    ...mapState(useColorManagementStore, ['availablePmsColors']),
    ...mapState(useProductStore, ['data', 'activePosition']),
    ...mapState(useShapeStore, ['positionShapes']),

    textShapes(): AnnotationShape[] {
      if (this.activePosition && this.activePosition.id) {
        return this.positionShapes(this.activePosition.id).filter(
          (shape) => shape.kind === 'Text'
        );
      } else {
        return [];
      }
    },
    logoShapes(): AnnotationShape[] {
      if (this.activePosition && this.activePosition.id) {
        return this.positionShapes(this.activePosition.id).filter(
          (shape) => shape.kind === 'Logo'
        );
      } else {
        return [];
      }
    },
  },

  methods: {
    ...mapActions(useColorManagementStore, ['getPmsColorsOnPrintPosition']),
  },
});
